'use client'

import { alpha } from '@mui/material/styles'
import { Typography } from '@mui/material'

// Types
import type { TotalItemsProps } from '@/types/components/molecules/gallery/total-items'

const TotalItemsMolecule = (props: TotalItemsProps) => {
	// Props
	const { selected, total } = props

	return (
		<Typography
			component="p"
			px={2}
			position="absolute"
			top={25}
			right={36}
			fontSize={16}
			fontWeight={700}
			color="common.white"
			bgcolor={alpha('#fff', 0.35)}
			border="2px solid #fff"
			borderRadius={1}
			zIndex={1}
			sx={{ cursor: 'default' }}
		>
			{selected} / {total}
		</Typography>
	)
}

export default TotalItemsMolecule
